<template>
  <layout title="AGB" :banner="$page.props.banner" h1="AGB">
    <section id="agb-content">
      <div class="scol-section bg-light">
        <div class="container text-center">
          <h2 class="text-secondary mb-5">
            Reisebedingungen
          </h2>
          <a href="files/pdf/scol-skireisen-agb-25-26.pdf" class="btn btn-primary rounded-pill" title="SCOL Skireisen - Allgemeine Geschäftsbedingungen" download>
            <i class="fa-solid fa-download me-2"></i>
            AGB
          </a>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from "./Layouts/Standard";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default {
  components: {
    Layout,
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    info: {
      itemsToShow: 2,
      snapAlign: "start",
      breakpoints: {
        700: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
      },
    },
    galerie: {
      itemsToShow: 3,
      wrapAround: true,
      snapAlign: "start",
      arrows: true,
    },
  }),
};
</script>
